import React, { CSSProperties, useEffect } from 'react';
import cx from 'classnames';

import styles from './CountdownBar.module.css';
import Box, { BoxStyleProps } from '../Box';

export interface CountdownBarProps extends BoxStyleProps {
  className?: string;
  state?: 'playing' | 'paused' | 'reset';
  duration?: number;
  color?: 'default' | 'warning';
  startingPercentage?: number;
}

export default function CountdownBar({
  className,
  state = 'paused',
  duration = 3000,
  color = 'default',
  startingPercentage = 100,
  ...otheProps
}: CountdownBarProps): JSX.Element {
  const [key, setKey] = React.useState(0);

  useEffect(() => {
    if (state === 'reset') {
      setKey(key + 1);
    }
  }, [state]);

  return (
    <Box
      className={cx(
        styles['base'],
        [styles[`base--color-${color}`]],
        { [styles['is-running']]: state === 'playing' },
        className
      )}
      {...otheProps}
    >
      <div
        data-test-id="countdown-bar-inner"
        className={styles['inner']}
        key={key}
        style={
          {
            '--u-countdownBar-animation-duration': `${duration}ms`,
            width: `${startingPercentage}%`,
          } as CSSProperties
        }
      />
    </Box>
  );
}
